import Button from '@restart/ui/esm/Button'
import axios from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import SimpleReactValidator from 'simple-react-validator'
import { toast } from 'react-toastify'
import DashboardMainTitle from '../../../dashboardTitle/DashboardMainTitle'
import { fetchSaloons } from '../../../../redux/action/saloons/saloons';
import { useDispatch, useSelector } from 'react-redux'
import { fetchCsrfCookie } from '../../../../redux/action/csrf/csrf-cookie'
import { fetchProvince } from '../../../../redux/action/province/province'
import { fetchCity } from '../../../../redux/action/province/city'
import SmallLoading from '../../../../utils/SmallLoading'
import { useTranslation } from 'react-i18next'
import {IoCloseCircleOutline} from 'react-icons/io5'

const CreateStall = (props) => {
    const {t} = useTranslation();
    const [btnLoading, setBtnLoading] = useState(false)
    const [errors, setErrors] = useState({})
    const [forceUpdate, setForceUpdate] = useState(0)
    const [confirmLogo, setConfirmLogo] = useState(false)
    const [typingTimeout, setTypingTimeout] = useState(0)
    const saloons = useSelector(state => state.saloons.saloons)
    const province = useSelector(state => state.province)
    const city = useSelector(state => state.city)
    const dispatch = useDispatch()

    const [data, setData] = useState({
        title: "",
        description: "",
        manager_name: "",
        manager_mobile: "",
        username: "",
        password: "",
        confirm_password: "",
        address: "",
        phone: "",
        saloon_id: props.id,
        brand: "",
        location: "",
        province: "",
        city: "",
        zone: "",
        factory_address: "",
        email: ""
    })

    const changeHandler = event => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const confirmPasswordHandler = event => {
        setData({ ...data, [event.target.name]: event.target.value })
        if (typingTimeout) { 
            clearTimeout(typingTimeout) 
        }
        setTypingTimeout(setTimeout(function () {
            if(data.password !== event.target.value ) {
                setConfirmLogo(true)
            } else {
                setConfirmLogo(false)
            }
        }, 1000))
    }

    const changeProvinceHandler = event => {
        setData({ ...data, [event.target.name]: event.target.value })
        let Id = parseInt(event.target.value)
        dispatch(fetchCity(event.target.value))
    }

    const validator = useRef(new SimpleReactValidator({
        messages: {
          required:"پر کردن این فیلد الزامی است",
          min: " تعداد کاراکترهای ورودی کم است " ,
          email: " محتوای ورودی صحیح نیست "
        },
    }))

    useEffect(() => {
        dispatch(fetchSaloons())
        dispatch(fetchProvince())
    }, [])

    const handleFromSubmit = (e) => {
        e.preventDefault()
        setBtnLoading(true)
        if (validator.current.allValid()) {
            dispatch(fetchCsrfCookie())
            axios.post('/admin/register/co', data, {withCredentials: true})
            .then(res => {
                setBtnLoading(false)
                toast.dismiss()
                toast.success(t("toast_successfully_created") , {position: 'bottom-right',className: 'foo-bar'})
                props.hide()
            })
            .catch(err => {
                setBtnLoading(false)
                setForceUpdate(1)
                setErrors(err.response.data.errors)
                toast.dismiss()
                toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})
            })
        } else if (data.manager_mobile < 11) {
            setBtnLoading(false)
            setForceUpdate(1)
            validator.current.showMessages()
            toast.dismiss()
            toast.error(t("toast_phone_number_not_valid") , {position: 'bottom-right',className: 'foo-bar'})
        } else if (data.password.length < 8) {
            setBtnLoading(false)
            setForceUpdate(1)
            validator.current.showMessages()
            toast.dismiss()
            toast.error(t("toast_password_must_have_atleast_8_characters") , {position: 'bottom-right'})
        }  else if (parseInt(data.confirm_password) !== parseInt(data.password)) {
            setForceUpdate(1)
            setBtnLoading(false)
            validator.current.showMessages()
            toast.dismiss()
            toast.error(t("toast_repeat_password_does_not_match") , {position: 'bottom-right'})
        } else {
            setBtnLoading(false)
            setForceUpdate(1)
            validator.current.showMessages()
            toast.dismiss()
            toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})
        }
    }

    return (
            <>
                <DashboardMainTitle> {t("create new company")} </DashboardMainTitle>
                <div className="form-container mb-4">
                    <Form onSubmit={e => handleFromSubmit(e)}>
                        <Form.Group className="mb-3 col-lg-5" controlId="title">
                            <Form.Label>{t("company name")} : </Form.Label>
                            <Form.Control type="text"  name="title" value={data.title} onChange={changeHandler} />
                            <span className='validator_error'>{validator.current.message('title', data.title, 'required')}</span>
                        </Form.Group>
                        {errors.title && errors.title.map(i => <p style={{color: 'red', lineHeight: 1}} key={i}>{i}</p>)}

                        <Form.Group className="mb-3 col-lg-5" controlId="description">
                            <Form.Label> {t("explanations")} : </Form.Label>
                            <Form.Control as="textarea" rows={3} name="description" value={data.description} onChange={changeHandler} />
                            <span className='validator_error'>{validator.current.message('description', data.description, 'required')}</span>
                        </Form.Group>
                        {errors.description && errors.description.map(i => <p style={{color: 'red', lineHeight: 1}} key={i}>{i}</p>)}

                        <Form.Group className="mb-3 col-lg-5" controlId="manager_name">
                            <Form.Label> {t("CEO name")} : </Form.Label>
                            <Form.Control type="text" name="manager_name" value={data.manager_name} onChange={changeHandler} />
                            <span className='validator_error'>{validator.current.message('manager_name', data.manager_name, 'required')}</span>
                        </Form.Group>
                        {errors.manager_name && errors.manager_name.map(i => <p style={{color: 'red', lineHeight: 1}} key={i}>{i}</p>)}

                        <Form.Group className="mb-3 col-lg-5" controlId="manager_mobile">
                            <Form.Label> {t("CEO phone number")} : </Form.Label>
                            <Form.Control type="text" name="manager_mobile" value={data.manager_mobile} onChange={changeHandler} />
                            <span className='validator_error'>{validator.current.message('manager_mobile', data.manager_mobile, 'required')}</span>
                        </Form.Group>
                        {errors.manager_mobile && errors.manager_mobile.map(i => <p style={{color: 'red', lineHeight: 1}} key={i}>{i}</p>)}

                        <Form.Group className="mb-3 col-lg-5" controlId="email">
                            <Form.Label> {t("email address")} : </Form.Label>
                            <Form.Control type="email" name="email" value={data.email} onChange={changeHandler} />
                            <span className='validator_error'>{validator.current.message('email', data.email, 'required')}</span>
                        </Form.Group>
                        {errors.email && errors.email.map(i => <p style={{color: 'red', lineHeight: 1}} key={i}>{i}</p>)}

                        <Form.Group className="mb-3 col-lg-5" controlId="username">
                            <Form.Label> {t("username")} : </Form.Label>
                            <Form.Control type="text" name="username" value={data.username} onChange={changeHandler} />
                            <span className='validator_error'>{validator.current.message('username', data.username, 'required')}</span>
                        </Form.Group>
                        {errors.username && errors.username.map(i => <p style={{color: 'red', lineHeight: 1}} key={i}>{i}</p>)}

                        <Row>
                            <Col md>
                                <Form.Group className="mb-3 col-md-10" controlId="password">
                                    <Form.Label> {t("password")} : </Form.Label>
                                    <Form.Control type="password" name="password" value={data.password} onChange={confirmPasswordHandler} />
                                    <span className='validator_error'>{validator.current.message('password', data.password, 'required')}</span>
                                </Form.Group>
                                {errors.password && errors.password.map(i => <p style={{color: 'red', lineHeight: 1}} key={i}>{i}</p>)}

                            </Col>
                            <Col md>
                                <Form.Group className="mb-3 col-md-10 confirm_wrapper" controlId="confirm_password">
                                    <Form.Label> {t("repeat password")} : </Form.Label>
                                    <Form.Control type="password" name="confirm_password" value={data.confirm_password} onChange={confirmPasswordHandler} />
                                    {confirmLogo ? <IoCloseCircleOutline title='تکرار رمز عبور مطابقت ندارد' className='pass_validator' /> : "" }
                                    <span className='validator_error'>{validator.current.message('confirm_password', data.confirm_password, 'required')}</span>
                                </Form.Group>
                                {errors.confirm_password && errors.confirm_password.map(i => <p style={{color: 'red', lineHeight: 1}} key={i}>{i}</p>)}

                            </Col>
                        </Row>

                        <Form.Group className="mb-3 col-lg-5" controlId="address">
                            <Form.Label> {t("Central office address")} : </Form.Label>
                            <Form.Control as="textarea" rows={3} name="address" value={data.address} onChange={changeHandler} />
                            <span className='validator_error'>{validator.current.message('address', data.address, 'required')}</span>
                        </Form.Group>
                        {errors.address && errors.address.map(i => <p style={{color: 'red', lineHeight: 1}} key={i}>{i}</p>)}

                        <Form.Group className="mb-3 col-lg-5" controlId="phone">
                            <Form.Label> {t("Central office phone")} : </Form.Label>
                            <Form.Control type="text" name="phone" value={data.phone} onChange={changeHandler} />
                            <span className='validator_error'>{validator.current.message('phone', data.phone, 'required')}</span>
                        </Form.Group>
                        {errors.phone && errors.phone.map(i => <p style={{color: 'red', lineHeight: 1}} key={i}>{i}</p>)}

                        <Row>
                            <Col md>
                                <Form.Group className="mb-3 col-md-10" controlId="saloon_id">
                                    <Form.Label> {t("Activity categories")} :  </Form.Label>
                                    <Form.Select aria-label="Floating label select" name="saloon_id" value={data.saloon_id} onChange={changeHandler} >
                                        <option value="" hidden> {t("Activity")} </option>
                                        {saloons.map(saloon =>
                                            <option key={saloon.id} value={saloon.id}>{saloon.name}</option>
                                        )}
                                    </Form.Select>
                                </Form.Group>
                                <span className='validator_error'>{validator.current.message('saloon_id', data.saloon_id, 'required')}</span>
                                {errors.saloon_id && errors.saloon_id.map(i => <p style={{color: 'red', lineHeight: 1}} key={i}>{i}</p>)}

                            </Col>
                            <Col md>
                                <Form.Group className="mb-3 col-md-10" controlId="brand">
                                    <Form.Label> {t("brand")} : </Form.Label>
                                    <Form.Control type="text" name="brand" value={data.brand} onChange={changeHandler} />
                                    <span className='validator_error'>{validator.current.message('brand', data.brand, 'required')}</span>
                                </Form.Group>
                                {errors.brand && errors.brand.map(i => <p style={{color: 'red', lineHeight: 1}} key={i}>{i}</p>)}
                            </Col>
                        </Row>
                        
                        <Row>
                            <Col md>
                                <Form.Group className="mb-3 col-md-10" controlId="province">
                                    <Form.Label> {t("province")} : </Form.Label>
                                    <Form.Select name="province" value={data.province} onChange={id => changeProvinceHandler(id)} >
                                        {city.loading ?
                                            <SmallLoading />
                                        :
                                            province.province ?
                                                <>
                                                    <option value="" disabled> {t("province")}</option>    
                                                    {province.province.map(item => (
                                                        <option value={item.id} key={item.id}>{item.title}</option>
                                                    ))}
                                                </>
                                            :
                                                ''
                                        }
                                    </Form.Select>
                                    <span className='validator_error'>{validator.current.message('province', data.province, 'required')}</span>
                                </Form.Group>
                                {errors.province && errors.province.map(i => <p style={{color: 'red', lineHeight: 1}} key={i}>{i}</p>)}
                            </Col>
                            <Col md>
                                <Form.Group className="mb-3 col-md-10" controlId="city">
                                    <Form.Label> {t("city")} : </Form.Label>
                                    <Form.Select name="city" value={data.city} onChange={changeHandler} >
                                        {city.loading ?
                                            <SmallLoading />
                                        :
                                            city.city ? 
                                                <>
                                                <option value="" disabled> {t("city")}</option>    
                                                {city.city.map(item => (
                                                    <option value={item.id} key={item.id}>{item.title}</option>
                                                ))}
                                                </>
                                            :
                                                <option value="" disabled>{t("choose province")}</option>    
                                        }
                                    </Form.Select>
                                    <span className='validator_error'>{validator.current.message('city', data.city, 'required')}</span>
                                </Form.Group>
                                {errors.city && errors.city.map(i => <p style={{color: 'red', lineHeight: 1}} key={i}>{i}</p>)}
                            </Col>
                        </Row>

                        <Form.Group className="mb-3 col-lg-5" controlId="location">
                            <Form.Label> {t("Location of the factory")} : </Form.Label>
                            <Form.Control type="text" name="location" value={data.location} onChange={changeHandler} />
                            <span className='validator_error'>{validator.current.message('location', data.location, 'required')}</span>
                        </Form.Group>
                        {errors.location && errors.location.map(i => <p style={{color: 'red', lineHeight: 1}} key={i}>{i}</p>)}

                        <Form.Group className="mb-3 col-lg-5" controlId="zone">
                            <Form.Label> {t("area where the factory is located")} : </Form.Label>
                            <Form.Control type="text" name="zone" value={data.zone} onChange={changeHandler} />
                            <span className='validator_error'>{validator.current.message('zone', data.zone, 'required')}</span>
                        </Form.Group>
                        {errors.zone && errors.zone.map(i => <p style={{color: 'red', lineHeight: 1}} key={i}>{i}</p>)}

                        <Form.Group className="mb-3 col-lg-5" controlId="factory_address">
                            <Form.Label> {t("full address")} : </Form.Label>
                            <Form.Control as="textarea" rows={3} name="factory_address" value={data.factory_address} onChange={changeHandler} />
                            <span className='validator_error'>{validator.current.message('factory_address', data.factory_address, 'required')}</span>
                        </Form.Group>
                        {errors.factory_address && errors.factory_address.map(i => <p style={{color: 'red', lineHeight: 1}} key={i}>{i}</p>)}

                        <Button variant="primary" type="submit" className="btn green-btn mt-3" disabled={btnLoading ? true : false}>
                            {t("create")}
                        </Button>
                    </Form>
                </div>
            </>
    )
}

export default CreateStall

